<template>
	<line-chart ref="cpuTrendChart" :chartData="cpu.trend.chartData" :options="cpu.trend.chartOptions">
	</line-chart>
</template>

<script>
import {HTTP} from '../../services/HttpService'
import {colorService} from '../../services/ColorService'
import LineChart from '../LineChart.vue'

export default {
  components: {
    LineChart
  },
  name: 'cpu-chart',
  props: {
    config: Object
  },
  data: () => ({
    refreshInterval: null,
    cpu: {
      trend: {
        chartData: {
          labels: [],
          datasets: [ {
            fill: true,
            backgroundColor: '#9fcdff',
            borderColor: '#9fcdff',
            data: []
          }, {
            fill: true,
            backgroundColor: '#f1b0b7',
            borderColor: '#f1b0b7',
            data: []
          }]
        },
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          animation: {
            duration: 0
          },
          legend: {
            display: false
          },
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                max: 100
              }
            }]
          }
        }
      }
    }
  }),
  methods: {
    colorSeverity (color, value) {
      console.log(colorService.colorHexToRGBA(color, value / 100))
      return colorService.colorHexToRGBA(color, value / 100)
    },
    loadFirstTime () {
      HTTP.get('dashboard')
        .then(response => {
          this.metrics = response.data
          this.cpu.trend.chartData.datasets = []
          for (var i in this.metrics) {
            var server = this.metrics[i]
            var labels = []
            var cpuUsageTrend = []
            for (var j in server.metrics) {
              var metric = server.metrics[j]
              labels.push('')
              cpuUsageTrend.push(metric.cpu.usage)
            }
            var dataset = {
              fill: true,
              backgroundColor: colorService.colorHexToRGBA(server.server.color, 0.5),
              borderColor: server.server.color,
              borderWidth: 1,
              pointRadius: 1,
              data: cpuUsageTrend
            }
            // update cpu trend data
            this.cpu.trend.chartData.labels = labels
            this.cpu.trend.chartData.datasets.push(dataset)
          }
          this.$refs.cpuTrendChart.updateChart()
        })
    },
    loadLatest () {
      HTTP.get('metrics/metrics', {
        params: {
          serverIds: this.config.serverIds
        }})
        .then(response => {
          let serverMetrics = response.data
          for (let i in serverMetrics) {
            let serverMetric = serverMetrics[i]
            let chartData = this.cpu.trend.chartData.datasets[i].data
            // this.cpu.trend.chartData.labels.push('')
            chartData.shift()
            chartData.push(serverMetric.metric.cpu.usage)
          }
          this.$refs.cpuTrendChart.updateChart()
        })
    },
    fullScreen () {
      this.$refs.container.webkitRequestFullscreen()
    }
  },
  created () {
    this.loadFirstTime()
    console.log('first time...')
    this.refreshInterval = setInterval(this.loadLatest, 1000)
  },
  destroyed () {
    clearInterval(this.refreshInterval)
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// CpuChart.vue?112667f9